<mat-expansion-panel class="n-history-panel" [expanded]="false" style="margin-top:10px;">
    <mat-expansion-panel-header>
        <mat-panel-title style="margin: 15px 0px;">
            <div style="display:flex; gap: 10px;">
                <mat-icon>history</mat-icon>
                <span matBadge="{{history().length}}" matBadgeOverlap="false" matBadgeSize="large">Changelog</span>
            </div>
        </mat-panel-title>
    </mat-expansion-panel-header>

    @if (loading()) {
    <div class="n-spinner-container">
        <mat-spinner diameter="32"></mat-spinner>
    </div>
    }
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
        <!-- when Column -->
        <ng-container matColumnDef="updatedOn">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
            <td mat-cell *matCellDef="let element"> {{element.updatedOn}} </td>
        </ng-container>

        <!-- who Column -->
        <ng-container matColumnDef="updatedBy">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Who </th>
            <td mat-cell *matCellDef="let element"> {{element.updatedBy}} </td>
        </ng-container>

        <!-- what Column -->
        <ng-container matColumnDef="change">
            <th mat-header-cell *matHeaderCellDef> Change </th>
            <td mat-cell *matCellDef="let element"> {{element | historyDescription: entityType()}} </td>
        </ng-container>

        <ng-container matColumnDef="imported">
            <th mat-header-cell *matHeaderCellDef> Imported change? </th>
            <td mat-cell *matCellDef="let element"> {{(element.imported ? 'yes' : 'no')}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr *matNoDataRow>
            <td class="mat-cell" colspan="3">No history yet</td>
        </tr>
    </table>

</mat-expansion-panel>